import {
  EntKind,
  type TransitionsV3BreakdownOptions,
  type TransitionsV3Filters,
} from '@revelio/data-access';

import { type Filter, FilterId } from '../types/filters';
import { getStaticListFilter } from './get-static-list-filter';

const getGeoBreakdownLevel = (filters: TransitionsV3Filters): EntKind => {
  if (filters.city?.length || filters.msa?.length || filters.state?.length)
    return EntKind.City;
  if (filters.country?.length) return EntKind.Msa;
  if (filters.region?.length) return EntKind.Country;
  return EntKind.Region;
};

const getRicsBreakdownLevel = (filters: TransitionsV3Filters): EntKind => {
  if (filters.rics_k400?.length || filters.rics_k50?.length)
    return EntKind.RicsK400;
  if (filters.rics_k10?.length) return EntKind.RicsK50;
  return EntKind.RicsK10;
};

/** We want role levels to match the filter role levels (1 / 3 / 5 / 7) */
const getRoleBreakdownLevel = (filters: TransitionsV3Filters): EntKind => {
  if (
    filters.role_level_7?.length ||
    filters.role_level_6?.length ||
    filters.role_level_5?.length
  )
    return EntKind.RoleLvl_7;
  if (filters.role_level_4?.length || filters.role_level_3?.length)
    return EntKind.RoleLvl_5;
  if (filters.role_level_2?.length || filters.role_level_1?.length)
    return EntKind.RoleLvl_3;
  return EntKind.RoleLvl_1;
};

export const getTransitionsV3BreakdownOptions = ({
  filters,
  transitionsFilters,
}: {
  filters: Filter[];
  transitionsFilters: TransitionsV3Filters;
}): TransitionsV3BreakdownOptions => {
  const contingentWorkersFilter: boolean = (() => {
    const filter = getStaticListFilter({
      filters,
      filterId: FilterId.CONTINGENT_WORKERS,
    });
    if (filter === undefined) return false;
    return filter.selections?.[0]?.id === 'true';
  })();

  return {
    with_contingent_workers: contingentWorkersFilter,
    geo_breakdown_level: getGeoBreakdownLevel(transitionsFilters),
    rics_breakdown_level: getRicsBreakdownLevel(transitionsFilters),
    role_breakdown_level: getRoleBreakdownLevel(transitionsFilters),
  };
};
